import React, { useEffect, useRef, useState } from "react";
import "./Schedule.css";
import NormalAlert from "../AlertComponent/NormalAlert";
import { GetInterviewDetails } from "./InterviewService";
import { ScheduleInterview } from "./InterviewService";
import { useParams, useNavigate } from "react-router-dom";

const getLocalMinDateTime = () => {
  const now = new Date();
  now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
  return now.toISOString().slice(0, 16);
};

const InterviewSchedule = () => {
  const navigate = useNavigate();
  const { InterviewUID } = useParams(); // <-- get UID from URL
  const [minDateTime, setMinDateTime] = useState(getLocalMinDateTime());
  const timerRef = useRef(null);
  const [alert, setAlert] = useState(null);

  // Candidate & Job details
  const [candidateName, setCandidateName] = useState("");
  const [jobTitle, setJobTitle] = useState("");

  useEffect(() => {
    setMinDateTime(getLocalMinDateTime());

    const fetchInterviewDetails = async () => {
      try {
        const response = await GetInterviewDetails(InterviewUID);
        setCandidateName(response.data.candidateName || "");
        setJobTitle(response.data.jobTitle || "");
      } catch (error) {
        setAlert({
          type: "fail",
          message: "Failed to load interview details",
        });
        navigate(`/Interview-Scheduling-Request/${InterviewUID}`, {
          replace: true,
        });
      }
    };

    if (InterviewUID) {
      fetchInterviewDetails();
    }

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [InterviewUID]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData);

    const now = new Date();
    const selectedDate = new Date(data.interviewDate);

    if (selectedDate < now) {
      setAlert({
        type: "fail",
        message: "Date cannot be in the past",
      });
      return;
    }

    try {
      const payload = {
        interviewUID: InterviewUID,
        interviewDateTime: data.interviewDate, // already in yyyy-MM-ddTHH:mm format
      };
      const response = await ScheduleInterview(payload);

      if (response.data?.status === "success") {
        setAlert({
          type: "success",
          message: "Interview scheduled successfully!",
        });
      } else {
        setAlert({
          type: "fail",
          message: response.data?.message || "Failed to schedule interview",
        });
      }
    } catch (error) {
      setAlert({
        type: "fail",
        message: "Something went wrong while scheduling",
      });
    }
  };

  return (
    <div
      className="container"
      style={{ paddingTop: "10vh", paddingBottom: "5rem" }}
    >
      <div className="row justify-content-center">
        <div className="col-lg-6 col-md-8">
          <div className="scheduler-card p-5">
            <div className="text-center mb-4">
              <div className="header-icon">
                <i className="bi bi-calendar-check"></i>
              </div>
              <h2 className="fw-bold text-dark mb-2">Schedule Interview</h2>
            </div>

            <form id="scheduleForm" onSubmit={handleSubmit}>
              <div className="mb-4">
                <label htmlFor="candidateName" className="form-label">
                  <i className="bi bi-person-fill me-2"></i>Candidate Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="candidateName"
                  placeholder="Candidate's full name"
                  value={candidateName}
                  disabled
                  name="candidateName"
                />
              </div>

              <div className="mb-4">
                <label htmlFor="jobTitle" className="form-label">
                  <i className="bi bi-briefcase-fill me-2"></i>Job Title
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="jobTitle"
                  placeholder="Job Title"
                  name="jobTitle"
                  value={jobTitle}
                  disabled
                />
              </div>

              <div className="mb-4">
                <label htmlFor="interviewDate" className="form-label">
                  <i className="bi bi-calendar3 me-2"></i>Interview Date &amp;
                  Time
                </label>
                <input
                  type="datetime-local"
                  className="form-control"
                  id="interviewDate"
                  required
                  min={minDateTime}
                  name="interviewDate"
                />
              </div>

              <div className="d-grid">
                <button type="submit" className="btn btn-primary btn-schedule">
                  <i className="bi bi-calendar-plus me-2"></i>Schedule Interview
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {alert && (
        <NormalAlert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      )}
    </div>
  );
};

export default InterviewSchedule;
